import { render, staticRenderFns } from "./CncBadgeLabel.vue?vue&type=template&id=d808395c"
import script from "./CncBadgeLabel.vue?vue&type=script&lang=js"
export * from "./CncBadgeLabel.vue?vue&type=script&lang=js"
import style0 from "./CncBadgeLabel.vue?vue&type=style&index=0&id=d808395c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports